<template>
    <div v-if="myErrors.length">
        <small class="form-text text-danger" v-for="(value, index) in myErrors" :key="index">
            {{value}}
        </small>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    props: ['name', 'errors'],
    computed: {
        myErrors() {
            if (this.errors) {
                return _.get(this.errors, this.name) || []
            }
            return _.get(this.$store.state.errors, this.name) || []
        },
    },
}
</script>
